import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getGenerationSalesMaster,
  listBgMasters,
  listGenerationSalesMasters,
  updateGenerationSalesMaster,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 発電販売計画マスタ 更新 mutation hook。
 * optimistic locking: expected_updated_at を request に含める。
 * onSuccess で listGenerationSalesMasters と listBgMasters (配下発電所数) を invalidate してテーブルを最新化する。
 */
export function useUpdateGenerationSalesMaster(): InvalidatingMutationResultFor<
  typeof updateGenerationSalesMaster
> {
  return useInvalidatingMutation(updateGenerationSalesMaster, [
    createConnectQueryKey({
      schema: listGenerationSalesMasters,
      cardinality: 'finite',
    }),
    // 開き直した時に保存前の内容が出ないよう、1 件の取得も取り直す
    createConnectQueryKey({
      schema: getGenerationSalesMaster,
      cardinality: 'finite',
    }),
    // BG 一覧の「配下発電所数」は発電販売計画マスタの発電所情報から導出されるので、BG タブ・CSV も取り直す
    createConnectQueryKey({
      schema: listBgMasters,
      cardinality: 'finite',
    }),
  ])
}
